import { Outlet } from "react-router-dom"
import { CssBaseline ,Container,Box} from '@mui/material'
import Header from "./Header";
import Header2 from "./header2";
import Footer from "./footer"
const Shared = () => {
    
    return (
        <>
<Header />
                <Header2 />
                <CssBaseline />
                <Container fixed>
                    
                <Outlet />
      </Container>
           <Footer/>
        </>
    )
}
export default Shared;